export const API_BASE_URL = '/api';

export const APP_ROOT_ID = 'root';
